/** @param {{ is_private_booking?: boolean, booking_source?: string, booking?: { booking_source?: string } }} row */
export const isPrivateBooking = (row) =>
  row?.is_private_booking === true ||
  row?.booking_source === 'vendor_manual' ||
  row?.booking?.booking_source === 'vendor_manual';

export const PRIVATE_BOOKING_LABEL = 'Private booking';

export const PRIVATE_PAYOUT_EXCLUDED_NOTE = 'Not included in platform payouts';
